module.exports = __webpack_public_path__ + "static/media/CICLO_3_GÉNERO_DIGITAL_2022.ff3aea9a.jpg";